import { render, staticRenderFns } from "./ReportImpianto.vue?vue&type=template&id=12b16fab&"
import script from "./ReportImpianto.vue?vue&type=script&lang=js&"
export * from "./ReportImpianto.vue?vue&type=script&lang=js&"
import style0 from "./ReportImpianto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports